import React, { useState } from 'react';

import PropTypes from 'prop-types';
import RoomHeader from '../../Card/CardRoom';
import Image from '../../../atoms/image/Image';
import DsList from '../../../atoms/list';
import PriceGroup from '../../../molecules/price/priceGroup';
import { getOccupancyLabel } from '../../../../../utils/Room';
import RoomDetail from '../../../../booking/rooms/RoomDetail';

const MBRoom = ({
  children, className, room, roomIndex,
}, context) => {
  const [showModal, setModal] = useState(false);
  // ADD LANG CHANGE
  const modelListItems = room.key_selling_points.map((item) => ({ title: item.text }));
  return (
  <div className={` ${className || ''}`}>
    <RoomHeader
      title={room.room.name}
      roomIndex={roomIndex}
      guests={getOccupancyLabel(room.occupancy, context)}
      className="text-lg"
      // seeDetails={() => setModal(true)}
    />
    <div className="flex flex-wrap md:flex-nowrap mb-4">
      <div className="flex-grow-default flex flex-wrap">
        <div className="w-full sm:w-32">
          <Image img={room.room.photos.length > 0
            && room.room.photos[0].url
            ? room.room.photos[0].url : ''} alt={room.room.name} className="w-full"></Image>
        </div>
        <div className="w-full px-2 my-4 md:-my-1 sm:w-auto flex-grow-1">
          <header className="text-base uppercase text-primary font-bold">
        {room.board.name}
        </header>
        <DsList
          items={modelListItems}
          variant="check"
          iconClassName="text-status-green"
          className=" text-sm"
        />
        </div>
      </div>
      <div className="md:pl-6 md:mt-0 md:ml-auto self-end text-xl flex-grow-default flex">
        <PriceGroup
          className="mb-2 my-4 ml-auto px-4 md:my-0"
          amount={room.amount}
          nights={room.nights}
          currency={room.currency}
          roundAmount
        />
      </div>
    </div>
    {children}
    {showModal && <RoomDetail room={room} onCloseRoomDetails={() => setModal(false)}>
      Modal
    </RoomDetail>}
  </div>
  );
};
MBRoom.contextTypes = {
  t: PropTypes.func.isRequired,
};
MBRoom.propTypes = {
  roomIndex: PropTypes.number,
  room: PropTypes.object.isRequired,
};

export default MBRoom;
